import moment from 'moment'
import {Ivf, Icsi} from '../../../dictionaries/sample-fertilization-methods'
import * as SampleStatuses from '../../../dictionaries/sample-statuses'

export default {
    progress: {
        getNextSystemId: false,
        setCurrentSystemId: false,
        getCases: false,
        updateCase: false,
        createCase: false,
        createReport: false,
        copyReport: false,
        updateReport: false,
        deleteReport: false,
        downloadReport: false,
        sendReport: false,
        getSuitableBatch: false,
        getEditedCase: false,
        signReport: false,
        deleteSignFromReport: false,
        addSpecialistToReport: false,
        deleteSpecialistFromReport: false,
    },
    errorMessagesByFields: {},
    editedCase: null,
    currentSystemId: null,
    patientContext: null,
    availableSystemIds: [],
    drafts: {},
    cases: [],
    totalCases: 0,
    suitableBatch: {
        batch: null,
        availablePlaces: 0
    },
    pagination: {
        itemsPerPage: 40,
        page: 1
    },
    filters: {
        createdFrom: null,
        createdTo: moment().format('YYYY-MM-DD'),
        clientIds: [],
        batchId: null,
        searchString: null,
        strictSearch: false,
        needSignBy: null,
        reportStatuses: [],
        sampleStatuses: [],
        showCasesWithoutDocuments: false
    },
    availableFertilizationMethods: [
        {
            title: 'ЭКО',
            value: Ivf
        },
        {
            title: 'ИКСИ',
            value: Icsi
        }
    ],
    availableReportStatuses: [
        {
            title: 'Created',
            value: 'created'
        },
        {
            title: 'Validation',
            value: 'validation'
        },
        {
            title: 'Validated',
            value: 'validated'
        },
        {
            title: 'Sent',
            value: 'sent'
        },
    ],
    availableSampleStatuses: [
        {
            title: 'Archive',
            value: SampleStatuses.Archive
        },
        {
            title: 'Missing',
            value: SampleStatuses.Missing
        },
        {
            title: 'In work',
            value: SampleStatuses.InWork
        },
        {
            title: 'Report created',
            value: SampleStatuses.ReportCreated
        },
        {
            title: 'Validation',
            value: SampleStatuses.Validation
        },
        {
            title: 'Validated',
            value: SampleStatuses.Validated
        },
        {
            title: 'Sent',
            value: SampleStatuses.Sent
        }
    ],
    reportSampleTemplates: []
}